import React from "react";
import { getCertificationLogos } from "../data/certificationLogos";

/**
 * Row of official certification marks. Each logo keeps its own aspect ratio
 * (`object-contain` against a fixed box) so no mark is stretched or cropped.
 *
 * When the project holds no asset for the given standards it renders
 * `fallback`, or nothing if none was given. The fallback must never be a
 * stand-in MARK — the registry deliberately has no entry for a standard whose
 * logo the project does not hold — so pass a plainly decorative UI glyph, not
 * something that could read as a badge.
 */
const CertificationLogos = ({
  logoKeys,
  label,
  className = "mt-6 border-t border-gray-100 pt-5",
  size = "h-11 sm:h-12",
  fallback = null,
}) => {
  const logos = getCertificationLogos(logoKeys);
  if (logos.length === 0) return fallback;

  return (
    <div className={className}>
      <ul
        className="flex list-none flex-wrap items-center gap-x-6 gap-y-4 p-0"
        aria-label={label}
      >
        {logos.map((item) => (
          <li key={item.name}>
            <img
              src={item.src}
              alt={item.alt}
              loading="lazy"
              className={`${size} w-auto max-w-[9rem] object-contain`}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CertificationLogos;
